import { render, staticRenderFns } from "./changePw.vue?vue&type=template&id=f005bd0a"
import script from "./changePw.vue?vue&type=script&lang=js"
export * from "./changePw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f005bd0a')) {
      api.createRecord('f005bd0a', component.options)
    } else {
      api.reload('f005bd0a', component.options)
    }
    module.hot.accept("./changePw.vue?vue&type=template&id=f005bd0a", function () {
      api.rerender('f005bd0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/user/changePw.vue"
export default component.exports